<div [class.fx-hide]="!(showPickerFlag && showInputFlag)" class="picker-container">
  <div class="shortcut fxl-column fxla-center-center">
    <div class="pr-16 pl-16 flex-content-gap fxl-row-wrap fxla-center-center">
      @if (showTextInputFlag) {
        <div>
          <mat-form-field class="input-code">
            <mat-label>{{ matLabel }}</mat-label>
            <input
              #_inputText
              (keydown.enter)="handleEnterKey($event)"
              [formControl]="$any(formControl)"
              [matAutocomplete]="auto"
              matInput
              type="text"
            />
            <mat-autocomplete
              #auto="matAutocomplete"
              (closed)="closedHandler()"
              (opened)="openHandler()"
              (optionSelected)="optionSelectedHandler($event)"
              [panelWidth]="350"
              class="picker-autocomplete"
            >
              @for (item of autoCompleteResultList; track item.uuid) {
                <mat-option [id]="item.uuid" [value]="item.label">
                  <span [innerHTML]="highlight(item.label)"></span>
                </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
        </div>
      }
      <button (click)="clickHandler()" [disabled]="disableFlag" class="add-button" color="primary" mat-stroked-button type="button">
        {{ addButtonLabel }}
      </button>
    </div>
  </div>
</div>
@if (showPickerFlag && !showInputFlag) {
  <button
    (click)="clickHandler()"
    [attr.aria-label]="addButtonLabel"
    [disabled]="disableFlag"
    [matTooltip]="addButtonLabel"
    color="primary"
    mat-icon-button
  >
    @if (icon.startsWith('svg')) {
      <mat-icon svgIcon="{{ icon }}"></mat-icon>
    }
    @if (!icon.startsWith('svg')) {
      <mat-icon>{{ icon }}</mat-icon>
    }
  </button>
}
